const pad = (value) => String(value).padStart(2, "0");

export const PAGE_SIZE = 10;
export const DEFAULT_EXCHANGE_RATE = 2800;

export const isoDate = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export function currentMonthRange() {
  const now = new Date();
  return {
    start_date: isoDate(new Date(now.getFullYear(), now.getMonth(), 1)),
    end_date: isoDate(new Date(now.getFullYear(), now.getMonth() + 1, 0)),
  };
}

export function rangeForMode(mode, customStart, customEnd) {
  const now = new Date();

  if (mode === "DAY") {
    const today = isoDate(now);
    return { start_date: today, end_date: today };
  }

  if (mode === "WEEK") {
    const day = now.getDay() || 7;
    const start = new Date(now);
    start.setDate(now.getDate() - day + 1);
    const end = new Date(start);
    end.setDate(start.getDate() + 6);
    return { start_date: isoDate(start), end_date: isoDate(end) };
  }

  if (mode === "PERIOD") {
    const fallback = currentMonthRange();
    return {
      start_date: customStart || fallback.start_date,
      end_date: customEnd || fallback.end_date,
    };
  }

  return currentMonthRange();
}

export function isWithinRange(value, range) {
  if (!value) return false;
  const date = new Date(value).toISOString().slice(0, 10);
  return date >= range.start_date && date <= range.end_date;
}

export function paginateRows(rows, page, pageSize = PAGE_SIZE) {
  const totalPages = Math.max(1, Math.ceil(rows.length / pageSize));
  const safePage = Math.min(Math.max(page, 1), totalPages);
  const start = (safePage - 1) * pageSize;
  return {
    rows: rows.slice(start, start + pageSize),
    totalPages,
    safePage,
    from: rows.length ? start + 1 : 0,
    to: Math.min(start + pageSize, rows.length),
  };
}

export function convertAmount(value, sourceCurrency = "USD", targetCurrency = "USD", exchangeRate = DEFAULT_EXCHANGE_RATE) {
  const amount = Number(value || 0);
  const rate = Math.max(Number(exchangeRate || DEFAULT_EXCHANGE_RATE), 1);
  if (sourceCurrency === targetCurrency) return amount;
  if (sourceCurrency === "USD" && targetCurrency === "CDF") return amount * rate;
  if (sourceCurrency === "CDF" && targetCurrency === "USD") return amount / rate;
  return amount;
}

export function sumConverted(rows, amountKey, currencyKey = "currency", targetCurrency = "USD", exchangeRate = DEFAULT_EXCHANGE_RATE) {
  return rows.reduce(
    (sum, row) => sum + convertAmount(row[amountKey], row[currencyKey] || "USD", targetCurrency, exchangeRate),
    0
  );
}

export function totalsByCurrency(rows, amountKey, currencyKey = "currency") {
  return rows.reduce(
    (totals, row) => ({
      ...totals,
      [row[currencyKey] || "USD"]: Number(totals[row[currencyKey] || "USD"] || 0) + Number(row[amountKey] || 0),
    }),
    { USD: 0, CDF: 0 }
  );
}
